import {
  Card,
  CardContent,
  CardTitle,
} from "@/components/ui";
import { formatCurrencyShort } from "@/lib/utils";
import { ChartColumnBig, Columns3, UsersRound } from "lucide-react";
import { FormSectionHeader, Loader } from "@/components";
import useOperational from "./useOperational";

const Operational = () => {
  const {
    vendorGlData,
    isVendorGlDataLoading,
  } = useOperational();

  return (
    <Card className="shadow-none">
      <CardContent>
        <FormSectionHeader className="text-[18px] font-[500] flex flex-row items-center gap-2 text-primary">
          <ChartColumnBig className="h-6 w-6 stroke-2" /> OPERATIONAL INSIGHTS
        </FormSectionHeader>
        {isVendorGlDataLoading ? (
          <Loader />
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px]">
            <Card className="bg-blue-50 shadow-none pb-3">
              <CardTitle className="flex flex-row items-center gap-2 px-3 text-[16px] text-primary">
                <UsersRound className="h-[20px] w-[20px]" />
                Top 3 Vendors by Spend
              </CardTitle>
              <CardContent>
                <div className="grid grid-cols-1 gap-3">
                  <div className="grid grid-cols-1 text-[14px] mt-2 font-[500] gap-1 w-full">
                    {vendorGlData?.data?.topVendors?.map(
                      (data: any, index: number) => (
                        <div
                          className="flex flex-row items-center justify-between"
                          key={`vendors-${index}`}
                        >
                          <span className="text-gray-400">{index + 1}. {data?.name || ""}:{" "}</span>
                          <span>
                            {formatCurrencyShort(data?.amount || 0)}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card className="bg-amber-50 shadow-none pb-3">
              <CardTitle className="flex flex-row items-center gap-2 px-3 text-[16px] text-amber-600">
                <Columns3 className="h-[20px] w-[20px]" />
                Top 3 GL Accounts by Spend
              </CardTitle>
              <CardContent>
                <div className="grid grid-cols-1 gap-3">
                  <div className="grid grid-cols-1 text-[14px] mt-2 font-[500] gap-1 w-full">
                    {vendorGlData?.data?.topGls?.map(
                      (data: any, index: number) => (
                        <div
                          className="flex flex-row items-center justify-between"
                          key={`gls-${index}`}
                        >
                          <span className="text-gray-400">{index + 1}. {data?.name || ""}:{" "}</span>
                          <span>
                            {formatCurrencyShort(data?.amount || 0)}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default Operational;
